import { PaymentElement, useElements, useStripe } from "@stripe/react-stripe-js";
import Button from "../../../components/shared/Button";
import { useState } from "react";
import { toast } from "react-toastify";

// Add this component inside your ProviderAppointmentsDrawer file (or in a separate file)
 const PaymentForm = ({
  clientSecret,
  onSuccess,
  onClose,
}: {
  clientSecret: string;
  onSuccess: () => void;
  onClose: () => void;
}) => {
  const stripe = useStripe();
  const elements = useElements();
  const [isProcessing, setIsProcessing] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!stripe || !elements) {
      return;
    }

    setIsProcessing(true);

    const { error, setupIntent } = await stripe.confirmSetup({
      elements,
      confirmParams: {
        return_url: window.location.origin, 
      },
      redirect: "if_required",
    });

    if (error) {
      toast.error(error.message || "An unexpected error occurred");
      setIsProcessing(false);
      return;
    }

    if (
      setupIntent &&
      (setupIntent.status === "succeeded" || setupIntent.status === "processing")
    ) {
      // Success! The card has been saved
      toast.success("Card successfully saved!");
      setTimeout(() => {
        onSuccess();
        onClose();
      }, 1500);
    } else {
      toast.success("SetupIntent is in unexpected status: " + setupIntent?.status);
    }

    setIsProcessing(false);
  };

  return (
    <form onSubmit={handleSubmit} className="p-4">
      <PaymentElement
        options={{
          layout: "tabs",
        }}
      />
      <div className="mt-6 flex gap-4">
        <Button
          type="submit"
          variant="primary"
          label={isProcessing ? "Processing..." : "Save Card"}
          disabled={!stripe || isProcessing}
          // className="w-full"
        />
        <Button
          type="button"
          variant="secondary"
          label="Cancel"
          onClick={onClose}
          // className="w-full"
        />
      </div>
      {/* {message && (
        <div className="mt-4 text-center text-sm text-red-600">{message}</div>
      )} */}
    </form>
  );
};

export default PaymentForm;